export const administratorsApiErrorsTranslations = {
  RESOURCE_ALREADY_EXISTS: 'organizationDetails:admins.resourceAlreadyExists',
} as const;
